import type { ReactNode } from 'react';

import LucideSymbolIcon from '../icons/LucideSymbolIcon';

type ApprenantSectionCardProps = {
  id?: string;
  icon?: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  variant?: 'default' | 'summary' | 'accent';
  flush?: boolean;
};

export default function ApprenantSectionCard({
  id,
  icon,
  title,
  subtitle,
  action,
  children,
  variant = 'default',
  flush = false,
}: ApprenantSectionCardProps) {
  return (
    <section
      id={id}
      className={[
        'apprenant-section-card',
        variant === 'summary' && 'apprenant-section-card--summary',
        variant === 'accent' && 'apprenant-section-card--accent',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {variant !== 'summary' ? <div className="apprenant-section-card__accent" aria-hidden /> : null}
      <header className="apprenant-section-card__header">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          {icon ? (
            <span className="apprenant-section-card__icon" aria-hidden>
              <LucideSymbolIcon name={icon} tone="inherit" size={22} />
            </span>
          ) : null}
          <div className="min-w-0">
            <h2 className="apprenant-section-card__title">{title}</h2>
            {subtitle ? <p className="apprenant-section-card__subtitle">{subtitle}</p> : null}
          </div>
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </header>
      <div className={flush ? 'apprenant-section-card__body--flush' : 'apprenant-section-card__body'}>
        {children}
      </div>
    </section>
  );
}
